import { SendOutlined } from "@ant-design/icons";
import { useSignal } from "@preact/signals-react";
import styles from "./ChatInput.module.scss";
import TextArea from "antd/lib/input/TextArea";
import React, { useContext } from "react";
import { PublishSubscriptionStore } from "imagica-corekit/dist/cases/store/PublishSubscriptionStore";
import { FotAuthStore } from "imagica-corekit/dist/base/store/FotAuthStore";
import { GetItContext } from "../../base/provider/GetItContext";
import { useStore } from "../../hooks/useStore";
export function ChatInput(props) {
  var getIt = useContext(GetItContext);
  var submitEnabled = useSignal(false);
  var store = getIt(PublishSubscriptionStore);
  var state = useStore(store).value;
  var authStore = getIt(FotAuthStore);
  function sendMessage() {
    if (props.isLoading) {
      return;
    }
    if (props.onSendCliked) {
      props.onSendCliked();
    }
    props.inputText.value = "";
    submitEnabled.value = false;
  }
  function _onPressEnter(e) {
    e.preventDefault();
    //  如果是付费APP，并且没有付费
    if (state.isPaidApp && !state.isPay) {
      var _authStore$state;
      if (!(authStore !== null && authStore !== void 0 && (_authStore$state = authStore.state) !== null && _authStore$state !== void 0 && _authStore$state.brainToken)) {
        return store.setOpenPayWallAndLogin();
      }
      return store.setIsOpenPayWall(true);
    }
    sendMessage();
  }
  function onTextAreaChanged(e) {
    props.inputText.value = e.target.value;
    submitEnabled.value = e.target.value.length > 0;
    if (props.isInput) {
      props.isInput.value = true;
    }
  }
  function onTextAreaFoucs(e) {
    if (props.isInput) {
      props.isInput.value = true;
    }
    if (props.onFocusInput) {
      props.onFocusInput();
    }
  }
  function onTextAreaBlur(e) {
    if (props.isInput) {
      props.isInput.value = false;
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles["chat-input-box"]
  }, /*#__PURE__*/React.createElement(TextArea, {
    className: styles["chat-input"],
    value: props.inputText.value,
    onChange: function onChange(e) {
      return onTextAreaChanged(e);
    },
    onPressEnter: function onPressEnter(e) {
      return _onPressEnter(e);
    },
    onFocus: function onFocus(e) {
      return onTextAreaFoucs(e);
    },
    onBlur: function onBlur(e) {
      return onTextAreaBlur(e);
    },
    placeholder: "Start a message",
    autoSize: {
      minRows: 1,
      maxRows: props.isInCanvas ? 18 : 3
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles["chat-send-box"]
  }, /*#__PURE__*/React.createElement("div", {
    className: styles["chat-send"]
  }, /*#__PURE__*/React.createElement(SendOutlined, {
    style: {
      color: !props.isLoading && submitEnabled.value ? "#0A9DFF" : "#020C2659"
    },
    onClick: function onClick() {
      return sendMessage();
    }
  }))));
}